<script>
    export default {
        props: {
            selectedMarker: Object,
            dataConsumers: Array
        }
    };
</script>
<template>
    <div class="user-info">
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean bibendum arcu id tellus posuere tempor. </p>
    </div>
</template>
  
<style scoped>


    .user-info {
        z-index: 1;
        position: absolute;
        left: 50px; 
        top: 150px; 
        background-color: white;
        padding: 15px;
        border: 1px solid #ccc;
        border-radius: 10px;
        width: 300px;
    }
    /* @media (max-width: 1920px) {
        .user-info {
            top: 500px;
        }
    }
    @media (max-width: 1360px) {
        .user-info {
            top: 60%;
        }
    } */

</style>
  